<template lang="">
  <div class="cardContentT">
    <!--
    <div class="tab-box flex">
      <div
        v-for="(item, index) in typeList"
        :key="index"
        class="tab-item"
        :class="{ active: active === index }"
        @click="changeType(index, item)"
      >
        <span>{{ item }}</span>
      </div>
    </div> -->
    <div class="chart" ref="pieChart" />
  </div>
</template>

<script>
import { loadChart } from "../chart/chartData";
export default {
  data() {
    return {
      pieChart: null,
      active: 0,
      typeList: ["数量", "资金"]
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    changeType(index) {
      this.active = index;
    },
    initChart() {
      this.pieChart = this.$echarts.init(this.$refs.pieChart);
      const seriesData = [
        {
          name: "实施主体",
          value: 10
        },
        {
          name: "国家农业龙头企业",
          value: 1
        },
        {
          name: "省农业龙头企业",
          value: 9
        },
        {
          name: "地市级农业龙头企业",
          value: 21
        },
        {
          name: "其他企业",
          value: 25
        }
      ];
      loadChart(this.pieChart, seriesData);
      window.addEventListener("resize", () => {
        this.pieChart.resize();
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.cardContentT
  height 100%
  .chart
    height 100%
.tab-box
  position absolute
  top 60px
  right 4%
  z-index 999
  .tab-item
    color #fff
    font-size 10px
    padding-left 13px
    margin-right 50px
    position relative
    cursor pointer
    &:before
      content ' '
      width 24px
      height 14px
      border-radius 2px
      background #fff
      position absolute
      right 75%
      top 50%
      transform translateY(-50%)
  .tab-item:last-child
    margin-right 0
  .active
    color #0e9cff
    &:before
      background #0e9cff
</style>
